import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1e3a5f] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#d4af37] rounded-lg flex items-center justify-center">
                <i className="ri-hospital-line text-[#1e3a5f] text-2xl"></i>
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold leading-tight" style={{ fontFamily: '"Pacifico", serif' }}>Zeus</span>
                <span className="text-xs leading-tight">Specialty Infusion</span>
              </div>
            </div>
            <p className="text-sm text-gray-300">
              Professional outpatient specialty infusion care in Los Angeles.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm cursor-pointer">Home</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm cursor-pointer">Services</Link></li>
              <li><Link to="/physicians" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm cursor-pointer">For Physicians</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm cursor-pointer">About</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>IVIG Infusions</li>
              <li>Iron Infusions</li>
              <li>Biologic Infusions</li>
              <li>Specialty Medications</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-[#d4af37] mt-1"></i>
                <span>(555) 123-4567</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-[#d4af37] mt-1"></i>
                <span>inquiries@zsicenter.com</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-printer-line text-[#d4af37] mt-1"></i>
                <span>Fax: (555) 123-4568</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-[#d4af37] mt-1"></i>
                <span>Los Angeles, CA</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Zeus Specialty Infusion Nursing Corporation. All rights reserved. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors cursor-pointer">Powered by Readdy</a></p>
        </div>
      </div>
    </footer>
  );
}
